var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterBgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 511,
    height: 316,
    viewBox: "0 0 511 316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.839 38.2437L370.839 38.1681L390.331 4.48731L429.286 4.48731L429.286 4.56286L448.763 38.2437L429.331 71.9094L390.331 71.9094L370.839 38.2437ZM390.482 4.80461L371.187 38.2437L390.497 71.6827L429.119 71.6827L448.43 38.2437L429.119 4.78951L390.482 4.80461Z",
    fill: "url(#paint0_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.839 105.41L390.331 71.6836L429.286 71.6836L448.763 105.41L448.763 105.485L429.331 139.151L390.331 139.151L370.839 105.41ZM390.482 71.9707L371.171 105.41L390.497 138.864L429.119 138.864L448.43 105.41L429.119 71.9707L390.482 71.9707Z",
    fill: "url(#paint1_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.839 172.605L370.839 172.529L390.331 138.863L429.286 138.863L429.286 138.939L448.763 172.605L448.763 172.68L429.331 206.331L390.331 206.331L370.839 172.605ZM390.482 139.15L371.171 172.605L390.497 206.044L429.119 206.044L448.43 172.605L429.119 139.15L390.482 139.15Z",
    fill: "url(#paint2_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.839 239.785L370.839 239.71L390.331 206.044L429.286 206.044L429.286 206.12L448.763 239.785L448.763 239.861L429.331 273.526L390.331 273.526L370.839 239.785ZM390.482 206.331L371.171 239.785L390.497 273.224L429.119 273.224L448.43 239.785L429.119 206.331L390.482 206.331Z",
    fill: "url(#paint3_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.946 315.215L371.187 306.965L390.482 273.511L429.104 273.511L448.415 306.965L443.655 315.215L444.003 315.215L448.717 307.04L448.763 306.965L429.316 273.299L429.286 273.224L390.316 273.224L370.884 306.889L370.839 306.965L375.599 315.215L375.946 315.215Z",
    fill: "url(#paint4_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.661 71.8194L312.661 71.7438L332.138 38.0781L371.093 38.0781L371.093 38.1537L390.524 71.8194L390.524 71.8949L371.093 105.561L332.138 105.561L332.138 105.485L312.661 71.8194ZM332.305 38.3803L312.994 71.8194L332.305 105.274L370.926 105.274L390.237 71.8194L370.926 38.3803L332.305 38.3803Z",
    fill: "url(#paint5_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.661 139.015L312.661 138.939L332.138 105.273L371.093 105.273L371.093 105.349L390.524 139.015L371.093 172.726L332.138 172.726L312.661 139.015ZM332.305 105.561L312.994 139.015L332.305 172.454L370.926 172.454L390.237 139.015L370.926 105.561L332.305 105.561Z",
    fill: "url(#paint6_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.661 206.194L332.138 172.453L371.093 172.453L371.093 172.529L390.524 206.194L390.524 206.27L371.093 239.936L332.138 239.936L332.138 239.86L312.661 206.194ZM332.305 172.725L312.994 206.179L332.305 239.618L370.926 239.618L390.237 206.194L370.926 172.725L332.305 172.725Z",
    fill: "url(#paint7_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.661 273.375L312.661 273.299L332.138 239.634L371.093 239.634L371.093 239.709L390.524 273.375L390.524 273.451L371.093 307.116L332.138 307.116L332.138 307.041L312.661 273.375ZM332.305 239.936L312.994 273.375L332.305 306.829L370.926 306.829L390.237 273.375L370.926 239.936L332.305 239.936Z",
    fill: "url(#paint8_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.624 315.216L332.308 307.102L370.93 307.102L375.599 315.216L375.946 315.216L371.141 306.89L371.096 306.814L332.142 306.814L327.291 315.216L327.624 315.216Z",
    fill: "url(#paint9_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.475 172.605L254.475 172.529L273.906 138.863L312.921 138.863L312.921 138.939L332.368 172.605L332.368 172.68L312.936 206.331L273.967 206.331L254.475 172.605ZM274.118 139.15L254.822 172.605L274.118 206.044L312.74 206.044L332.051 172.605L312.74 139.15L274.118 139.15Z",
    fill: "url(#paint10_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.475 239.785L254.475 239.71L273.906 206.044L312.921 206.044L312.921 206.12L332.368 239.785L332.368 239.861L312.936 273.526L273.967 273.526L254.475 239.785ZM274.118 206.331L254.822 239.785L274.118 273.224L312.74 273.224L332.051 239.785L312.74 206.331L274.118 206.331Z",
    fill: "url(#paint11_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.567 315.215L254.808 306.965L274.119 273.511L312.74 273.511L332.051 306.965L327.292 315.215L327.624 315.215L332.354 307.04L332.384 306.965L312.952 273.299L312.907 273.224L273.952 273.224L254.521 306.889L254.475 306.965L259.235 315.215L259.567 315.215Z",
    fill: "url(#paint12_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.299 206.195L215.746 172.529L254.655 172.529L254.655 172.605L274.087 206.271L274.087 206.346L254.655 239.936L215.701 239.936L215.701 239.861L196.299 206.195ZM215.943 172.741L196.632 206.195L215.943 239.634L254.564 239.634L273.875 206.195L254.564 172.726L215.943 172.741Z",
    fill: "url(#paint13_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.299 273.375L196.299 273.299L215.746 239.634L254.655 239.634L254.655 239.709L274.087 273.375L274.087 273.451L254.655 307.116L215.701 307.116L215.701 307.041L196.299 273.375ZM215.943 239.936L196.632 273.375L215.943 306.829L254.564 306.829L273.875 273.375L254.564 239.936L215.943 239.936Z",
    fill: "url(#paint14_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.26 315.216L215.944 307.102L254.566 307.102L259.235 315.216L259.567 315.216L254.777 306.89L254.732 306.814L215.778 306.814L210.927 315.216L211.26 315.216Z",
    fill: "url(#paint15_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.11 239.785L138.11 239.71L157.542 206.044L196.542 206.044L196.542 206.12L215.974 239.785L215.974 239.861L196.527 273.526L157.572 273.526L138.11 239.785ZM157.754 206.331L138.443 239.785L157.754 273.224L196.376 273.224L215.687 239.785L196.376 206.331L157.754 206.331Z",
    fill: "url(#paint16_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.2 315.215L138.44 306.965L157.751 273.511L196.373 273.511L215.684 306.965L210.924 315.215L211.257 315.215L215.986 307.04L216.017 306.965L196.585 273.299L196.539 273.224L157.585 273.224L138.153 306.889L138.108 306.965L142.868 315.215L143.2 315.215Z",
    fill: "url(#paint17_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8926 315.216L99.5768 307.102L138.199 307.102L142.868 315.216L143.2 315.216L138.395 306.89L138.365 306.814L99.3955 306.814L94.5602 315.216L94.8926 315.216Z",
    fill: "url(#paint18_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000202166 172.74L21.819 172.74L41.13 206.179L21.8191 239.633L-0.000199242 239.633L-0.00019923 239.921L22.0004 239.921L41.4322 206.255L41.4775 206.179L22.0306 172.514L22.0004 172.453L-0.000202179 172.453L-0.000202166 172.74Z",
    fill: "url(#paint19_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.000202166 239.921L21.819 239.921L41.13 273.375L21.8191 306.814L-0.000199242 306.814L-0.00019923 307.101L22.0004 307.101L41.4322 273.451L41.4775 273.375L22.0306 239.709L22.0004 239.634L-0.000202179 239.634L-0.000202166 239.921Z",
    fill: "url(#paint20_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.106 162.314L478.06 162.314L453.219 119.295L478.06 76.2762L511.106 76.2762L511.106 74.75L477.184 74.75L451.466 119.295L477.184 163.825L511.106 163.825L511.106 162.314Z",
    fill: "url(#paint21_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.106 249.863L478.06 249.863L453.219 206.844L478.06 163.825L511.106 163.825L511.106 162.314L477.184 162.314L451.466 206.844L477.184 251.39L511.106 251.39L511.106 249.863Z",
    fill: "url(#paint22_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.06 251.389L511.106 251.389L511.106 249.863L477.184 249.863L451.466 294.408L463.479 315.215L465.232 315.215L453.219 294.408L478.06 251.389Z",
    fill: "url(#paint23_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.642 163.07L401.329 118.54L452.704 118.54L478.392 163.07L452.704 207.615L401.329 207.615L375.642 163.07ZM402.236 120.051L377.394 163.07L402.236 206.089L451.903 206.089L476.775 163.07L451.903 120.051L402.236 120.051Z",
    fill: "url(#paint24_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.642 250.634L401.329 206.089L452.704 206.089L478.392 250.634L452.78 295.119L401.405 295.119L375.642 250.634ZM402.236 207.615L377.394 250.634L402.236 293.608L451.903 293.608L476.775 250.634L451.903 207.615L402.236 207.615Z",
    fill: "url(#paint25_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.662 315.216L402.222 295.164L451.904 295.164L463.479 315.216L465.231 315.216L452.781 293.653L401.345 293.653L388.894 315.216L390.662 315.216Z",
    fill: "url(#paint26_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.806 206.86L325.493 162.314L376.868 162.314L402.556 206.86L376.868 251.39L325.493 251.39L299.806 206.86ZM326.4 163.841L301.498 206.86L326.339 249.879L376.082 249.879L400.909 206.86L376.082 163.841L326.4 163.841Z",
    fill: "url(#paint27_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.571 315.215L301.558 294.408L326.4 251.389L376.082 251.389L400.908 294.408L388.896 315.215L390.664 315.215L402.661 294.408L376.959 249.863L325.523 249.863L299.805 294.408L311.818 315.215L313.571 315.215Z",
    fill: "url(#paint28_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.002 315.216L250.577 295.164L300.244 295.164L311.818 315.216L313.571 315.216L301.12 293.653L249.7 293.653L237.249 315.216L239.002 315.216Z",
    fill: "url(#paint29_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M72.3175 250.634L98.0049 206.089L149.38 206.089L175.067 250.634L149.38 295.179L98.0049 295.179L72.3175 250.634ZM98.9116 207.615L74.0703 250.634L98.9116 293.608L148.594 293.608L173.42 250.589L148.594 207.57L98.9116 207.615Z",
    fill: "url(#paint30_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0.00243559 203.807L23.0909 163.825L72.7584 163.825L97.5997 206.844L72.7584 249.863L23.0909 249.863L0.00243586 209.897L0.00243599 212.934L22.1995 251.39L73.6349 251.39L99.3525 206.844L73.6349 162.314L22.1994 162.314L0.00243546 200.77L0.00243559 203.807Z",
    fill: "url(#paint31_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M97.5997 294.408L85.5871 315.215L87.3398 315.215L99.3525 294.408L73.6349 249.863L22.1994 249.863L0.00243546 288.334L0.00243559 291.371L23.0909 251.389L72.7584 251.389L97.5997 294.408Z",
    fill: "url(#paint32_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2627 315.215L0.00280094 297.445L0.00280107 300.482L8.49477 315.215L10.2627 315.215Z",
    fill: "url(#paint33_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0.0016004 212.934L21.7604 250.634L0.00160369 288.334L0.00160383 291.371L23.5283 250.634L0.00160027 209.896L0.0016004 212.934Z",
    fill: "url(#paint34_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M10.2627 315.215L0.00280094 297.445L0.00280107 300.482L8.49477 315.215L10.2627 315.215Z",
    fill: "url(#paint35_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.833 4.63885C433.833 3.72137 433.561 2.8245 433.051 2.06164C432.541 1.29878 431.817 0.704215 430.969 0.353111C430.122 0.002007 429.189 -0.0898536 428.289 0.0891377C427.389 0.268129 426.563 0.70994 425.914 1.3587C425.265 2.00745 424.823 2.83401 424.644 3.73386C424.465 4.63371 424.557 5.56644 424.908 6.41408C425.26 7.26172 425.854 7.98619 426.617 8.49592C427.38 9.00564 428.277 9.27771 429.194 9.27771C430.423 9.27373 431.601 8.78371 432.47 7.91462C433.339 7.04552 433.829 5.86792 433.833 4.63885Z",
    fill: "url(#paint36_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.503 4.63848C387.503 5.21227 387.673 5.77319 387.992 6.25028C388.311 6.72738 388.764 7.09923 389.294 7.31881C389.824 7.5384 390.408 7.59586 390.97 7.48392C391.533 7.37198 392.05 7.09566 392.456 6.68992C392.862 6.28419 393.138 5.76724 393.25 5.20447C393.362 4.64169 393.304 4.05838 393.085 3.52826C392.865 2.99814 392.493 2.54503 392.016 2.22624C391.539 1.90745 390.978 1.7373 390.404 1.7373C390.024 1.7373 389.646 1.81234 389.294 1.95814C388.942 2.10394 388.622 2.31765 388.353 2.58705C388.084 2.85645 387.87 3.17627 387.724 3.52826C387.578 3.88025 387.503 4.25749 387.503 4.63848Z",
    fill: "url(#paint37_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.406 38.2445C368.409 38.7615 368.565 39.266 368.855 39.6942C369.144 40.1224 369.555 40.4551 370.033 40.6502C370.512 40.8452 371.038 40.894 371.545 40.7902C372.051 40.6864 372.515 40.4347 372.879 40.067C373.242 39.6994 373.489 39.2321 373.586 38.7245C373.684 38.2168 373.63 37.6915 373.429 37.215C373.228 36.7385 372.891 36.3322 372.459 36.0474C372.028 35.7627 371.522 35.6123 371.005 35.6153C370.661 35.6173 370.322 35.6868 370.005 35.82C369.689 35.9532 369.402 36.1475 369.161 36.3916C368.919 36.6358 368.728 36.925 368.599 37.2429C368.469 37.5609 368.404 37.9012 368.406 38.2445Z",
    fill: "url(#paint38_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.249 38.2286C447.249 38.9713 447.851 39.5734 448.594 39.5734C449.336 39.5734 449.938 38.9713 449.938 38.2286C449.938 37.4859 449.336 36.8838 448.594 36.8838C447.851 36.8838 447.249 37.4859 447.249 38.2286Z",
    fill: "url(#paint39_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.534 71.8196C426.534 72.3455 426.69 72.8597 426.982 73.297C427.274 73.7344 427.689 74.0752 428.175 74.2765C428.661 74.4778 429.196 74.5305 429.712 74.4279C430.228 74.3253 430.702 74.072 431.074 73.7C431.446 73.3281 431.699 72.8542 431.801 72.3384C431.904 71.8225 431.851 71.2878 431.65 70.8018C431.449 70.3159 431.108 69.9005 430.671 69.6083C430.233 69.3161 429.719 69.1602 429.193 69.1602C428.488 69.1602 427.811 69.4403 427.313 69.9391C426.814 70.4378 426.534 71.1142 426.534 71.8196Z",
    fill: "url(#paint40_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.075 71.8195C395.075 70.896 394.801 69.9933 394.288 69.2255C393.775 68.4576 393.046 67.8592 392.193 67.5058C391.34 67.1524 390.401 67.0599 389.495 67.2401C388.59 67.4203 387.758 67.8649 387.105 68.5179C386.452 69.1709 386.007 70.0029 385.827 70.9086C385.647 71.8143 385.739 72.7531 386.092 73.6062C386.446 74.4594 387.044 75.1886 387.812 75.7017C388.58 76.2147 389.483 76.4885 390.406 76.4885C391.644 76.4885 392.832 75.9966 393.708 75.121C394.583 74.2454 395.075 73.0578 395.075 71.8195Z",
    fill: "url(#paint41_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.557 105.41C446.557 105.798 446.672 106.178 446.888 106.501C447.104 106.824 447.41 107.076 447.769 107.224C448.128 107.373 448.523 107.412 448.904 107.336C449.285 107.26 449.635 107.073 449.91 106.799C450.185 106.524 450.372 106.174 450.448 105.793C450.523 105.412 450.485 105.017 450.336 104.658C450.187 104.299 449.935 103.992 449.612 103.776C449.289 103.561 448.91 103.445 448.521 103.445C448.001 103.449 447.504 103.658 447.136 104.025C446.769 104.393 446.561 104.89 446.557 105.41Z",
    fill: "url(#paint42_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.568 139.014C425.568 139.731 425.781 140.433 426.18 141.029C426.578 141.625 427.144 142.09 427.807 142.365C428.47 142.639 429.199 142.711 429.902 142.571C430.606 142.431 431.252 142.086 431.759 141.578C432.266 141.071 432.612 140.425 432.752 139.722C432.892 139.018 432.82 138.289 432.545 137.626C432.271 136.964 431.806 136.397 431.21 135.999C430.613 135.6 429.912 135.388 429.195 135.388C428.233 135.388 427.311 135.77 426.631 136.45C425.95 137.13 425.568 138.052 425.568 139.014Z",
    fill: "url(#paint43_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.084 138.999C386.084 141.386 388.019 143.321 390.406 143.321C392.793 143.321 394.728 141.386 394.728 138.999C394.728 136.613 392.793 134.678 390.406 134.678C388.019 134.678 386.084 136.613 386.084 138.999Z",
    fill: "url(#paint44_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.327 172.604C446.327 173.053 446.46 173.491 446.709 173.864C446.958 174.236 447.312 174.527 447.726 174.698C448.141 174.87 448.596 174.915 449.036 174.827C449.476 174.74 449.88 174.524 450.196 174.207C450.513 173.89 450.729 173.486 450.817 173.047C450.904 172.607 450.859 172.151 450.688 171.737C450.516 171.323 450.226 170.969 449.853 170.72C449.48 170.471 449.042 170.338 448.594 170.338C447.993 170.338 447.416 170.577 446.991 171.002C446.566 171.427 446.327 172.003 446.327 172.604Z",
    fill: "url(#paint45_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.596 206.195C426.596 206.709 426.748 207.211 427.034 207.639C427.32 208.066 427.725 208.399 428.2 208.596C428.675 208.793 429.198 208.844 429.702 208.744C430.206 208.643 430.669 208.396 431.033 208.032C431.396 207.669 431.644 207.206 431.744 206.702C431.844 206.198 431.793 205.675 431.596 205.2C431.399 204.725 431.066 204.319 430.639 204.034C430.211 203.748 429.709 203.596 429.195 203.596C428.854 203.596 428.516 203.663 428.2 203.794C427.885 203.924 427.599 204.116 427.357 204.357C427.116 204.598 426.924 204.885 426.794 205.2C426.663 205.515 426.596 205.853 426.596 206.195Z",
    fill: "url(#paint46_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.546 206.18C388.546 207.206 389.378 208.038 390.404 208.038C391.431 208.038 392.263 207.206 392.263 206.18C392.263 205.153 391.431 204.321 390.404 204.321C389.378 204.321 388.546 205.153 388.546 206.18Z",
    fill: "url(#paint47_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.843 239.785C446.843 240.132 446.946 240.471 447.138 240.759C447.331 241.047 447.605 241.272 447.925 241.404C448.245 241.537 448.598 241.572 448.938 241.504C449.278 241.436 449.59 241.27 449.835 241.024C450.08 240.779 450.247 240.467 450.315 240.127C450.383 239.787 450.348 239.435 450.215 239.114C450.083 238.794 449.858 238.52 449.57 238.328C449.281 238.135 448.943 238.032 448.596 238.032C448.131 238.032 447.685 238.217 447.356 238.546C447.028 238.874 446.843 239.32 446.843 239.785Z",
    fill: "url(#paint48_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.442 273.375C426.442 273.919 426.604 274.451 426.906 274.903C427.208 275.355 427.637 275.708 428.14 275.916C428.642 276.124 429.195 276.178 429.729 276.072C430.262 275.966 430.752 275.704 431.137 275.32C431.522 274.935 431.783 274.445 431.89 273.912C431.996 273.378 431.941 272.825 431.733 272.323C431.525 271.82 431.172 271.391 430.72 271.088C430.268 270.786 429.736 270.625 429.192 270.625C428.463 270.625 427.763 270.915 427.248 271.43C426.732 271.946 426.442 272.646 426.442 273.375Z",
    fill: "url(#paint49_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.277 273.375C387.277 275.102 388.677 276.503 390.404 276.503C392.132 276.503 393.532 275.102 393.532 273.375C393.532 271.647 392.132 270.247 390.404 270.247C388.677 270.247 387.277 271.647 387.277 273.375Z",
    fill: "url(#paint50_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.965 306.965C445.965 307.485 446.119 307.993 446.408 308.426C446.697 308.858 447.108 309.195 447.588 309.394C448.069 309.593 448.597 309.645 449.107 309.544C449.617 309.442 450.086 309.192 450.454 308.824C450.821 308.457 451.072 307.988 451.173 307.478C451.275 306.968 451.222 306.439 451.023 305.959C450.824 305.479 450.488 305.068 450.055 304.779C449.623 304.49 449.114 304.336 448.594 304.336C448.249 304.336 447.907 304.404 447.588 304.536C447.269 304.668 446.979 304.862 446.735 305.106C446.491 305.35 446.298 305.64 446.165 305.959C446.033 306.278 445.965 306.62 445.965 306.965Z",
    fill: "url(#paint51_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.697 38.2439C328.697 38.9372 328.902 39.615 329.288 40.1915C329.673 40.768 330.22 41.2173 330.861 41.4826C331.501 41.7479 332.206 41.8174 332.886 41.6821C333.566 41.5468 334.191 41.213 334.681 40.7227C335.172 40.2324 335.505 39.6078 335.641 38.9278C335.776 38.2478 335.706 37.5429 335.441 36.9023C335.176 36.2618 334.727 35.7143 334.15 35.3291C333.574 34.9439 332.896 34.7383 332.202 34.7383C331.273 34.7383 330.381 35.1076 329.724 35.7651C329.066 36.4225 328.697 37.3141 328.697 38.2439Z",
    fill: "url(#paint52_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.802 105.409C372.802 105.054 372.696 104.706 372.499 104.41C372.301 104.115 372.02 103.884 371.692 103.748C371.363 103.612 371.002 103.576 370.653 103.646C370.304 103.715 369.984 103.887 369.732 104.138C369.481 104.389 369.309 104.71 369.24 105.059C369.171 105.407 369.206 105.769 369.342 106.098C369.478 106.426 369.709 106.707 370.005 106.905C370.3 107.102 370.648 107.208 371.004 107.208C371.24 107.21 371.475 107.164 371.694 107.075C371.913 106.985 372.112 106.853 372.28 106.685C372.447 106.518 372.579 106.319 372.669 106.1C372.759 105.881 372.804 105.646 372.802 105.409Z",
    fill: "url(#paint53_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.907 105.409C328.907 106.067 329.102 106.709 329.467 107.256C329.833 107.803 330.352 108.229 330.959 108.48C331.567 108.732 332.235 108.798 332.88 108.67C333.525 108.541 334.117 108.225 334.582 107.76C335.047 107.295 335.364 106.703 335.492 106.058C335.62 105.413 335.554 104.745 335.303 104.137C335.051 103.53 334.625 103.01 334.078 102.645C333.532 102.28 332.889 102.085 332.231 102.085C331.794 102.083 331.361 102.168 330.957 102.334C330.553 102.5 330.185 102.745 329.876 103.054C329.567 103.363 329.322 103.731 329.156 104.135C328.99 104.539 328.905 104.972 328.907 105.409Z",
    fill: "url(#paint54_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.73 138.999C310.73 140.159 311.67 141.099 312.83 141.099C313.99 141.099 314.931 140.159 314.931 138.999C314.931 137.839 313.99 136.898 312.83 136.898C311.67 136.898 310.73 137.839 310.73 138.999Z",
    fill: "url(#paint55_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.915 172.604C375.915 171.633 375.627 170.683 375.087 169.876C374.548 169.068 373.781 168.439 372.883 168.067C371.986 167.695 370.999 167.598 370.046 167.788C369.094 167.977 368.218 168.445 367.532 169.132C366.845 169.819 366.377 170.694 366.188 171.646C365.998 172.599 366.095 173.586 366.467 174.484C366.839 175.381 367.468 176.148 368.276 176.687C369.083 177.227 370.033 177.515 371.004 177.515C371.65 177.517 372.289 177.391 372.886 177.145C373.483 176.899 374.025 176.538 374.481 176.081C374.938 175.625 375.299 175.083 375.545 174.486C375.791 173.889 375.917 173.25 375.915 172.604Z",
    fill: "url(#paint56_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.378 239.785C367.369 240.508 367.576 241.217 367.971 241.822C368.366 242.427 368.933 242.901 369.598 243.183C370.264 243.465 370.998 243.543 371.708 243.406C372.417 243.269 373.071 242.925 373.584 242.416C374.097 241.907 374.447 241.257 374.59 240.548C374.732 239.839 374.661 239.104 374.384 238.437C374.107 237.769 373.638 237.198 373.037 236.798C372.435 236.398 371.728 236.186 371.005 236.189C370.048 236.188 369.13 236.566 368.451 237.24C367.772 237.914 367.386 238.828 367.378 239.785Z",
    fill: "url(#paint57_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.201 273.375C309.201 274.092 309.414 274.793 309.812 275.389C310.211 275.986 310.777 276.45 311.44 276.725C312.102 276.999 312.832 277.071 313.535 276.931C314.239 276.791 314.885 276.446 315.392 275.939C315.899 275.432 316.244 274.786 316.384 274.082C316.524 273.379 316.453 272.649 316.178 271.987C315.904 271.324 315.439 270.758 314.842 270.359C314.246 269.961 313.545 269.748 312.828 269.748C312.351 269.746 311.878 269.839 311.437 270.02C310.997 270.202 310.596 270.469 310.259 270.806C309.922 271.143 309.655 271.544 309.473 271.984C309.292 272.425 309.199 272.898 309.201 273.375Z",
    fill: "url(#paint58_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.938 239.785C327.935 240.634 328.184 241.466 328.654 242.173C329.123 242.881 329.793 243.433 330.576 243.76C331.36 244.088 332.224 244.175 333.057 244.011C333.891 243.847 334.657 243.439 335.258 242.84C335.86 242.24 336.27 241.476 336.437 240.643C336.604 239.81 336.52 238.946 336.195 238.161C335.871 237.376 335.321 236.705 334.615 236.233C333.909 235.761 333.079 235.509 332.229 235.509C331.094 235.509 330.004 235.959 329.2 236.76C328.396 237.562 327.942 238.65 327.938 239.785Z",
    fill: "url(#paint59_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.122 306.965C367.119 307.738 367.346 308.494 367.773 309.137C368.2 309.78 368.809 310.282 369.522 310.579C370.235 310.876 371.02 310.955 371.777 310.805C372.535 310.655 373.231 310.283 373.777 309.737C374.323 309.191 374.695 308.495 374.845 307.737C374.995 306.98 374.916 306.195 374.619 305.482C374.322 304.769 373.82 304.16 373.177 303.733C372.534 303.306 371.778 303.079 371.005 303.082C369.977 303.086 368.991 303.496 368.264 304.224C367.536 304.951 367.126 305.937 367.122 306.965Z",
    fill: "url(#paint60_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.831 74.6143C313.383 74.6143 313.924 74.4503 314.384 74.1431C314.843 73.836 315.202 73.3994 315.413 72.8886C315.625 72.3778 315.68 71.8157 315.572 71.2735C315.464 70.7312 315.198 70.2331 314.807 69.8422C314.416 69.4512 313.918 69.185 313.376 69.0772C312.834 68.9693 312.272 69.0246 311.761 69.2362C311.25 69.4478 310.813 69.8061 310.506 70.2658C310.199 70.7255 310.035 71.266 310.035 71.8188C310.035 72.5602 310.33 73.2713 310.854 73.7955C311.378 74.3197 312.089 74.6143 312.831 74.6143Z",
    fill: "url(#paint61_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.963 172.589C329.963 173.833 330.971 174.841 332.214 174.841C333.458 174.841 334.466 173.833 334.466 172.589C334.466 171.346 333.458 170.338 332.214 170.338C330.971 170.338 329.963 171.346 329.963 172.589Z",
    fill: "url(#paint62_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.412 206.195C310.412 206.673 310.554 207.141 310.819 207.538C311.085 207.936 311.462 208.246 311.904 208.429C312.346 208.612 312.832 208.66 313.301 208.566C313.77 208.473 314.201 208.243 314.539 207.905C314.877 207.566 315.107 207.136 315.201 206.667C315.294 206.198 315.246 205.712 315.063 205.27C314.88 204.828 314.57 204.45 314.173 204.185C313.775 203.919 313.308 203.777 312.829 203.777C312.188 203.777 311.573 204.032 311.12 204.485C310.666 204.939 310.412 205.554 310.412 206.195Z",
    fill: "url(#paint63_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.253 306.966C252.253 308.284 253.322 309.353 254.641 309.353C255.959 309.353 257.028 308.284 257.028 306.966C257.028 305.647 255.959 304.578 254.641 304.578C253.322 304.578 252.253 305.647 252.253 306.966Z",
    fill: "url(#paint64_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.153 273.375C277.153 272.76 276.971 272.158 276.629 271.646C276.287 271.134 275.801 270.735 275.232 270.5C274.663 270.264 274.037 270.202 273.433 270.322C272.83 270.443 272.275 270.739 271.84 271.174C271.404 271.61 271.108 272.164 270.988 272.768C270.868 273.372 270.929 273.998 271.165 274.567C271.4 275.135 271.799 275.622 272.311 275.964C272.823 276.306 273.425 276.488 274.041 276.488C274.866 276.488 275.658 276.16 276.242 275.576C276.825 274.993 277.153 274.201 277.153 273.375Z",
    fill: "url(#paint65_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.239 306.965C329.239 308.609 330.572 309.942 332.216 309.942C333.86 309.942 335.192 308.609 335.192 306.965C335.192 305.321 333.86 303.988 332.216 303.988C330.572 303.988 329.239 305.321 329.239 306.965Z",
    fill: "url(#paint66_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.638 139.015C277.641 138.303 277.432 137.606 277.039 137.013C276.646 136.419 276.085 135.956 275.428 135.681C274.771 135.407 274.048 135.334 273.349 135.471C272.651 135.608 272.008 135.949 271.504 136.451C270.999 136.954 270.655 137.594 270.515 138.292C270.375 138.99 270.446 139.714 270.717 140.372C270.989 141.03 271.45 141.593 272.042 141.989C272.634 142.385 273.33 142.596 274.041 142.596C274.993 142.596 275.905 142.219 276.579 141.548C277.253 140.877 277.634 139.966 277.638 139.015Z",
    fill: "url(#paint67_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.655 168.872C253.917 168.872 253.196 169.091 252.582 169.501C251.968 169.911 251.49 170.494 251.207 171.176C250.925 171.858 250.851 172.608 250.995 173.332C251.139 174.056 251.494 174.721 252.016 175.243C252.538 175.765 253.203 176.121 253.927 176.265C254.651 176.409 255.402 176.335 256.084 176.052C256.766 175.77 257.349 175.292 257.759 174.678C258.169 174.064 258.388 173.343 258.388 172.604C258.39 172.114 258.294 171.627 258.108 171.174C257.921 170.72 257.646 170.308 257.299 169.961C256.952 169.614 256.54 169.339 256.086 169.152C255.632 168.965 255.146 168.87 254.655 168.872Z",
    fill: "url(#paint68_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.213 206.179C194.213 207.423 195.221 208.431 196.464 208.431C197.708 208.431 198.716 207.423 198.716 206.179C198.716 204.936 197.708 203.928 196.464 203.928C195.221 203.928 194.213 204.936 194.213 206.179Z",
    fill: "url(#paint69_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.919 172.59C212.919 174.209 214.232 175.521 215.851 175.521C217.47 175.521 218.782 174.209 218.782 172.59C218.782 170.971 217.47 169.658 215.851 169.658C214.232 169.658 212.919 170.971 212.919 172.59Z",
    fill: "url(#paint70_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.913 206.18C270.913 207.907 272.314 209.307 274.041 209.307C275.769 209.307 277.169 207.907 277.169 206.18C277.169 204.452 275.769 203.052 274.041 203.052C272.314 203.052 270.913 204.452 270.913 206.18Z",
    fill: "url(#paint71_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.409 239.785C211.409 242.239 213.398 244.228 215.852 244.228C218.305 244.228 220.294 242.239 220.294 239.785C220.294 237.332 218.305 235.343 215.852 235.343C213.398 235.343 211.409 237.332 211.409 239.785Z",
    fill: "url(#paint72_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.957 273.375C193.957 273.872 194.104 274.357 194.38 274.769C194.655 275.182 195.047 275.503 195.505 275.693C195.964 275.883 196.468 275.932 196.955 275.836C197.441 275.739 197.888 275.5 198.239 275.149C198.59 274.798 198.829 274.351 198.925 273.865C199.022 273.378 198.973 272.874 198.783 272.416C198.593 271.957 198.271 271.566 197.859 271.29C197.446 271.014 196.961 270.867 196.465 270.867C195.8 270.867 195.162 271.131 194.692 271.602C194.221 272.072 193.957 272.71 193.957 273.375Z",
    fill: "url(#paint73_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.243 239.785C250.24 240.659 250.497 241.514 250.98 242.242C251.464 242.97 252.153 243.538 252.96 243.873C253.767 244.209 254.655 244.298 255.512 244.128C256.37 243.958 257.157 243.538 257.775 242.92C258.393 242.302 258.814 241.514 258.983 240.657C259.153 239.8 259.064 238.911 258.729 238.104C258.393 237.298 257.825 236.609 257.097 236.125C256.369 235.641 255.514 235.385 254.64 235.388C253.474 235.388 252.355 235.851 251.531 236.676C250.706 237.5 250.243 238.619 250.243 239.785Z",
    fill: "url(#paint74_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.856 306.965C213.856 308.067 214.749 308.96 215.85 308.96C216.952 308.96 217.845 308.067 217.845 306.965C217.845 305.864 216.952 304.971 215.85 304.971C214.749 304.971 213.856 305.864 213.856 306.965Z",
    fill: "url(#paint75_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1728 206.195C82.1758 205.781 82.0556 205.376 81.8277 205.031C81.5997 204.686 81.2742 204.416 80.8925 204.256C80.5109 204.097 80.0904 204.054 79.6845 204.134C79.2786 204.214 78.9057 204.413 78.6132 204.705C78.3206 204.998 78.1217 205.371 78.0417 205.777C77.9618 206.183 78.0043 206.603 78.164 206.985C78.3237 207.366 78.5933 207.692 78.9386 207.92C79.2838 208.148 79.689 208.268 80.1027 208.265C80.3745 208.265 80.6437 208.212 80.8949 208.108C81.146 208.003 81.3742 207.851 81.5665 207.659C81.7587 207.467 81.9112 207.238 82.0152 206.987C82.1192 206.736 82.1728 206.467 82.1728 206.195Z",
    fill: "url(#paint76_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.259 206.195C155.259 206.673 155.401 207.141 155.667 207.538C155.933 207.936 156.31 208.246 156.752 208.429C157.194 208.612 157.68 208.66 158.149 208.566C158.618 208.473 159.049 208.243 159.387 207.905C159.725 207.566 159.955 207.136 160.048 206.667C160.142 206.198 160.094 205.712 159.911 205.27C159.728 204.828 159.418 204.45 159.02 204.185C158.623 203.919 158.155 203.777 157.677 203.777C157.036 203.777 156.421 204.032 155.968 204.485C155.514 204.939 155.259 205.554 155.259 206.195Z",
    fill: "url(#paint77_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M143.005 239.785C143.005 238.85 142.728 237.935 142.208 237.158C141.688 236.38 140.949 235.774 140.085 235.416C139.221 235.058 138.27 234.964 137.353 235.147C136.435 235.329 135.593 235.779 134.931 236.441C134.27 237.102 133.819 237.945 133.637 238.863C133.454 239.78 133.548 240.731 133.906 241.595C134.264 242.459 134.87 243.198 135.648 243.718C136.426 244.237 137.34 244.515 138.275 244.515C139.53 244.515 140.733 244.016 141.62 243.129C142.507 242.242 143.005 241.04 143.005 239.785Z",
    fill: "url(#paint78_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.11 273.375C155.11 273.883 155.26 274.38 155.542 274.803C155.825 275.225 156.226 275.554 156.695 275.749C157.165 275.943 157.681 275.994 158.179 275.895C158.678 275.796 159.135 275.551 159.495 275.192C159.854 274.833 160.099 274.375 160.198 273.877C160.297 273.378 160.246 272.862 160.052 272.392C159.857 271.923 159.528 271.522 159.105 271.24C158.683 270.957 158.186 270.807 157.678 270.807C156.997 270.807 156.344 271.077 155.862 271.559C155.38 272.041 155.11 272.694 155.11 273.375Z",
    fill: "url(#paint79_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M134.439 306.965C134.436 307.727 134.659 308.473 135.08 309.108C135.501 309.743 136.101 310.24 136.804 310.534C137.507 310.828 138.281 310.908 139.029 310.762C139.777 310.616 140.465 310.252 141.006 309.715C141.547 309.179 141.917 308.493 142.068 307.747C142.22 307 142.147 306.225 141.858 305.52C141.569 304.814 141.078 304.211 140.446 303.785C139.814 303.359 139.07 303.13 138.308 303.127C137.802 303.125 137.3 303.223 136.832 303.414C136.364 303.606 135.938 303.888 135.579 304.245C135.219 304.601 134.934 305.025 134.738 305.492C134.543 305.958 134.441 306.459 134.439 306.965Z",
    fill: "url(#paint80_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M104.626 306.966C104.626 305.95 104.325 304.956 103.76 304.111C103.196 303.266 102.393 302.608 101.455 302.219C100.516 301.83 99.4828 301.729 98.4862 301.927C97.4896 302.125 96.5742 302.614 95.8557 303.333C95.1372 304.051 94.6479 304.967 94.4497 305.963C94.2515 306.96 94.3532 307.993 94.742 308.932C95.1309 309.87 95.7894 310.673 96.6342 311.237C97.4791 311.802 98.4724 312.103 99.4885 312.103C100.851 312.103 102.158 311.562 103.121 310.598C104.085 309.635 104.626 308.328 104.626 306.966Z",
    fill: "url(#paint81_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M41.3111 208.99C41.8646 208.99 42.4057 208.826 42.8657 208.518C43.3257 208.21 43.684 207.773 43.8951 207.261C44.1062 206.749 44.1607 206.187 44.0516 205.644C43.9425 205.101 43.6748 204.603 43.2823 204.213C42.8899 203.822 42.3903 203.557 41.8471 203.451C41.3038 203.345 40.7414 203.403 40.2308 203.617C39.7203 203.83 39.2848 204.191 38.9794 204.653C38.6741 205.114 38.5127 205.656 38.5157 206.21C38.5157 206.576 38.5881 206.939 38.7288 207.277C38.8694 207.616 39.0755 207.923 39.3353 208.181C39.5951 208.44 39.9034 208.644 40.2425 208.783C40.5815 208.922 40.9447 208.992 41.3111 208.99Z",
    fill: "url(#paint82_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M76.46 273.375C76.4571 274.095 76.6681 274.801 77.0664 275.402C77.4647 276.003 78.0324 276.472 78.6975 276.75C79.3627 277.028 80.0953 277.102 80.8027 276.963C81.5101 276.824 82.1604 276.479 82.6712 275.97C83.182 275.461 83.5303 274.813 83.6721 274.106C83.8138 273.399 83.7426 272.666 83.4674 272C83.1922 271.333 82.7255 270.764 82.1263 270.363C81.5272 269.962 80.8225 269.748 80.1016 269.748C79.6241 269.746 79.1509 269.838 78.7092 270.02C78.2674 270.201 77.8659 270.468 77.5275 270.805C77.1892 271.142 76.9207 271.542 76.7375 271.983C76.5543 272.424 76.46 272.897 76.46 273.375Z",
    fill: "url(#paint83_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M44.9384 273.375C44.9414 272.654 44.73 271.948 44.331 271.347C43.9321 270.745 43.3635 270.276 42.6974 269.999C42.0314 269.721 41.298 269.648 40.5902 269.788C39.8824 269.928 39.2321 270.275 38.7219 270.785C38.2117 271.296 37.8646 271.946 37.7246 272.654C37.5846 273.361 37.6579 274.095 37.9354 274.761C38.2129 275.427 38.682 275.995 39.2832 276.394C39.8843 276.793 40.5905 277.005 41.312 277.002C42.2726 276.998 43.1927 276.615 43.8719 275.935C44.5511 275.256 44.9345 274.336 44.9384 273.375Z",
    fill: "url(#paint84_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.0258 172.604C19.0288 173.173 19.1995 173.727 19.5165 174.199C19.8335 174.671 20.2826 175.038 20.8076 175.255C21.3326 175.473 21.91 175.53 22.4676 175.421C23.0252 175.312 23.5381 175.04 23.942 174.64C24.3458 174.241 24.6227 173.731 24.7379 173.174C24.8531 172.618 24.8015 172.04 24.5896 171.512C24.3776 170.985 24.0147 170.532 23.5464 170.211C23.0782 169.889 22.5253 169.712 21.9572 169.703C21.5736 169.699 21.1931 169.771 20.8376 169.915C20.4821 170.059 20.1587 170.272 19.8861 170.542C19.6135 170.812 19.3971 171.133 19.2495 171.487C19.1018 171.841 19.0257 172.221 19.0258 172.604Z",
    fill: "url(#paint85_linear_457_762)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.7221 239.785C18.7221 240.416 18.9091 241.032 19.2594 241.556C19.6098 242.081 20.1077 242.489 20.6903 242.731C21.2728 242.972 21.9139 243.035 22.5324 242.912C23.1508 242.789 23.7189 242.485 24.1648 242.039C24.6107 241.594 24.9144 241.025 25.0374 240.407C25.1604 239.789 25.0972 239.147 24.8559 238.565C24.6146 237.982 24.206 237.484 23.6817 237.134C23.1573 236.784 22.5409 236.597 21.9104 236.597C21.4911 236.595 21.0756 236.676 20.6879 236.835C20.3002 236.995 19.9479 237.23 19.6514 237.526C19.355 237.823 19.1202 238.175 18.9607 238.563C18.8012 238.95 18.7201 239.366 18.7221 239.785Z",
    fill: "url(#paint86_linear_457_762)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_457_762",
    x1: 448.763,
    y1: 4.4873,
    x2: 443.768,
    y2: 93.4842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_457_762",
    x1: 448.763,
    y1: 71.6836,
    x2: 443.762,
    y2: 160.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_457_762",
    x1: 448.763,
    y1: 138.863,
    x2: 443.762,
    y2: 227.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_457_762",
    x1: 448.763,
    y1: 206.044,
    x2: 443.76,
    y2: 295.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_457_762",
    x1: 448.763,
    y1: 273.224,
    x2: 446.822,
    y2: 328.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_457_762",
    x1: 390.524,
    y1: 38.0781,
    x2: 385.517,
    y2: 127.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_457_762",
    x1: 390.524,
    y1: 105.273,
    x2: 385.522,
    y2: 194.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_457_762",
    x1: 390.524,
    y1: 172.453,
    x2: 385.517,
    y2: 261.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_457_762",
    x1: 390.524,
    y1: 239.634,
    x2: 385.517,
    y2: 328.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_457_762",
    x1: 375.946,
    y1: 306.814,
    x2: 375.822,
    y2: 317.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_457_762",
    x1: 332.368,
    y1: 138.863,
    x2: 327.365,
    y2: 227.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_457_762",
    x1: 332.368,
    y1: 206.044,
    x2: 327.363,
    y2: 295.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_457_762",
    x1: 332.384,
    y1: 273.224,
    x2: 330.442,
    y2: 328.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_457_762",
    x1: 274.087,
    y1: 172.529,
    x2: 269.086,
    y2: 261.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_457_762",
    x1: 274.087,
    y1: 239.634,
    x2: 269.075,
    y2: 328.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_457_762",
    x1: 259.567,
    y1: 306.814,
    x2: 259.443,
    y2: 317.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_457_762",
    x1: 215.974,
    y1: 206.044,
    x2: 210.967,
    y2: 295.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_457_762",
    x1: 216.017,
    y1: 273.224,
    x2: 214.075,
    y2: 328.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_457_762",
    x1: 143.2,
    y1: 306.814,
    x2: 143.076,
    y2: 317.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_457_762",
    x1: 41.4775,
    y1: 172.453,
    x2: 32.1565,
    y2: 260.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_457_762",
    x1: 41.4775,
    y1: 239.634,
    x2: 32.1565,
    y2: 327.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_457_762",
    x1: 511.106,
    y1: 74.75,
    x2: 499.787,
    y2: 191.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_457_762",
    x1: 511.106,
    y1: 162.314,
    x2: 499.787,
    y2: 279.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_457_762",
    x1: 511.106,
    y1: 249.863,
    x2: 504.987,
    y2: 335.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_457_762",
    x1: 478.392,
    y1: 118.54,
    x2: 471.781,
    y2: 236.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_457_762",
    x1: 478.392,
    y1: 206.089,
    x2: 471.787,
    y2: 323.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_457_762",
    x1: 465.231,
    y1: 293.653,
    x2: 464.709,
    y2: 322.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_457_762",
    x1: 402.556,
    y1: 162.314,
    x2: 395.945,
    y2: 279.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_457_762",
    x1: 402.661,
    y1: 249.863,
    x2: 399.101,
    y2: 336.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_457_762",
    x1: 313.571,
    y1: 293.653,
    x2: 313.048,
    y2: 322.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_457_762",
    x1: 175.067,
    y1: 206.089,
    x2: 168.454,
    y2: 323.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_457_762",
    x1: 99.3525,
    y1: 162.314,
    x2: 92.517,
    y2: 279.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_457_762",
    x1: 99.3525,
    y1: 249.863,
    x2: 95.6674,
    y2: 336.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_457_762",
    x1: 10.2627,
    y1: 297.445,
    x2: 7.65252,
    y2: 320.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_457_762",
    x1: 23.5283,
    y1: 209.896,
    x2: 0.4605,
    y2: 312.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_457_762",
    x1: 10.2627,
    y1: 297.445,
    x2: 7.65252,
    y2: 320.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_457_762",
    x1: 433.833,
    y1: 0,
    x2: 433.04,
    y2: 12.2337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_457_762",
    x1: 393.306,
    y1: 1.7373,
    x2: 392.809,
    y2: 9.38833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_457_762",
    x1: 373.634,
    y1: 35.6152,
    x2: 373.187,
    y2: 42.5091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_457_762",
    x1: 449.938,
    y1: 36.8838,
    x2: 449.708,
    y2: 40.4304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_457_762",
    x1: 431.853,
    y1: 69.1602,
    x2: 431.398,
    y2: 76.1736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_457_762",
    x1: 395.075,
    y1: 67.1504,
    x2: 394.277,
    y2: 79.4637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_457_762",
    x1: 450.485,
    y1: 103.445,
    x2: 450.149,
    y2: 108.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_457_762",
    x1: 432.821,
    y1: 135.388,
    x2: 432.201,
    y2: 144.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_457_762",
    x1: 394.728,
    y1: 134.678,
    x2: 393.988,
    y2: 146.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_457_762",
    x1: 450.86,
    y1: 170.338,
    x2: 450.473,
    y2: 176.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_457_762",
    x1: 431.794,
    y1: 203.596,
    x2: 431.349,
    y2: 210.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_457_762",
    x1: 392.263,
    y1: 204.321,
    x2: 391.945,
    y2: 209.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_457_762",
    x1: 450.349,
    y1: 238.032,
    x2: 450.049,
    y2: 242.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_457_762",
    x1: 431.942,
    y1: 270.625,
    x2: 431.472,
    y2: 277.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_457_762",
    x1: 393.532,
    y1: 270.247,
    x2: 392.997,
    y2: 278.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_457_762",
    x1: 451.224,
    y1: 304.336,
    x2: 450.774,
    y2: 311.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_457_762",
    x1: 335.708,
    y1: 34.7383,
    x2: 335.108,
    y2: 43.9833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_457_762",
    x1: 372.802,
    y1: 103.611,
    x2: 372.494,
    y2: 108.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_457_762",
    x1: 335.556,
    y1: 102.085,
    x2: 334.987,
    y2: 110.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_457_762",
    x1: 314.931,
    y1: 136.898,
    x2: 314.571,
    y2: 142.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_457_762",
    x1: 375.915,
    y1: 167.693,
    x2: 375.075,
    y2: 180.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_457_762",
    x1: 374.661,
    y1: 236.188,
    x2: 374.038,
    y2: 245.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_457_762",
    x1: 316.454,
    y1: 269.748,
    x2: 315.834,
    y2: 279.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_457_762",
    x1: 336.521,
    y1: 235.509,
    x2: 335.787,
    y2: 246.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_457_762",
    x1: 374.919,
    y1: 303.082,
    x2: 374.252,
    y2: 313.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_457_762",
    x1: 315.626,
    y1: 69.0234,
    x2: 315.148,
    y2: 76.3955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_457_762",
    x1: 334.466,
    y1: 170.338,
    x2: 334.081,
    y2: 176.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_457_762",
    x1: 315.247,
    y1: 203.777,
    x2: 314.834,
    y2: 210.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_457_762",
    x1: 257.028,
    y1: 304.578,
    x2: 256.62,
    y2: 310.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_457_762",
    x1: 277.153,
    y1: 270.263,
    x2: 276.621,
    y2: 278.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_457_762",
    x1: 335.192,
    y1: 303.988,
    x2: 334.683,
    y2: 311.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_457_762",
    x1: 277.638,
    y1: 135.403,
    x2: 277.023,
    y2: 144.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_457_762",
    x1: 258.388,
    y1: 168.872,
    x2: 257.749,
    y2: 178.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_457_762",
    x1: 198.716,
    y1: 203.928,
    x2: 198.331,
    y2: 209.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_457_762",
    x1: 218.782,
    y1: 169.658,
    x2: 218.281,
    y2: 177.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_457_762",
    x1: 277.169,
    y1: 203.052,
    x2: 276.634,
    y2: 211.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_457_762",
    x1: 220.294,
    y1: 235.343,
    x2: 219.534,
    y2: 247.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_457_762",
    x1: 198.974,
    y1: 270.867,
    x2: 198.545,
    y2: 277.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_457_762",
    x1: 259.067,
    y1: 235.388,
    x2: 258.313,
    y2: 247.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_457_762",
    x1: 217.845,
    y1: 304.971,
    x2: 217.504,
    y2: 310.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_457_762",
    x1: 82.1729,
    y1: 204.095,
    x2: 81.8162,
    y2: 209.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_457_762",
    x1: 160.095,
    y1: 203.777,
    x2: 159.681,
    y2: 210.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_457_762",
    x1: 143.005,
    y1: 235.056,
    x2: 142.196,
    y2: 247.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_457_762",
    x1: 160.247,
    y1: 270.807,
    x2: 159.808,
    y2: 277.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_457_762",
    x1: 142.146,
    y1: 303.127,
    x2: 141.486,
    y2: 313.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_457_762",
    x1: 104.626,
    y1: 301.828,
    x2: 103.747,
    y2: 315.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_457_762",
    x1: 44.1064,
    y1: 203.399,
    x2: 43.6283,
    y2: 210.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_457_762",
    x1: 83.7432,
    y1: 269.748,
    x2: 83.1203,
    y2: 279.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_457_762",
    x1: 44.9385,
    y1: 269.719,
    x2: 44.3156,
    y2: 279.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_457_762",
    x1: 24.7979,
    y1: 169.703,
    x2: 24.3042,
    y2: 177.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_457_762",
    x1: 25.0986,
    y1: 236.597,
    x2: 24.5533,
    y2: 245.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8538FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407406,
    stopColor: "#7E7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964538,
    stopColor: "#73EBFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBgImg);
export default __webpack_public_path__ + "static/media/footer-bg-img.165c9f9c7dc03bbaf65e082d1864c18f.svg";
export { ForwardRef as ReactComponent };